import { TranslateService } from '@ngx-translate/core';

/**
 * Keeps `<html lang>` in step with the language the UI is actually rendered in.
 *
 * `index.html` ships `lang="fr"` because that is `environment.defaultLocale`, but the header lets
 * the user switch to English. Leaving a stale `lang` is what invites Chrome to offer — or, once the
 * user has ticked "always translate", to silently apply — a page translation. That translation
 * rewrites the Material Symbols ligature names inside `<tds-icon>`, so icons turn into words.
 * The `notranslate` meta tag in `index.html` is the hard stop; this keeps the declaration honest,
 * which also matters for screen readers and hyphenation.
 */
export function syncDocumentLang(translateService: TranslateService) {
  return (): void => {
    const apply = (lang: string | undefined) => {
      if (lang) {
        document.documentElement.lang = lang;
      }
    };

    apply(translateService.currentLang ?? translateService.getDefaultLang());
    translateService.onLangChange.subscribe((event) => apply(event.lang));
  };
}
